import { assetUrl } from '../http/build-url';
import { asBoolean, asString, asStringArray } from '../http/normalise';
import { ApiSocialLink, ApiSpeaker } from './speaker.dto';
import { SocialLink, SocialPlatform, Speaker } from './speaker.model';

const PLATFORMS: ReadonlySet<string> = new Set<string>([
  'linkedin',
  'x',
  'website',
]);

function mapSocialLinks(
  dtos: ReadonlyArray<ApiSocialLink> | null | undefined
): ReadonlyArray<SocialLink> {
  if (!Array.isArray(dtos)) {
    return [];
  }

  return dtos.reduce<SocialLink[]>((links, dto) => {
    const url = asString(dto.url);
    const platform = asString(dto.platform);

    if (url === null || platform === null || !PLATFORMS.has(platform)) {
      return links;
    }

    links.push({ platform: platform as SocialPlatform, url });
    return links;
  }, []);
}

export function mapSpeaker(dto: ApiSpeaker, storageBase: string): Speaker {
  const headshotPath = asString(dto.headshotUrl);

  return {
    id: asString(dto.id) ?? '',
    eventId: asString(dto.eventId) ?? '',
    firstName: asString(dto.firstName) ?? '',
    lastName: asString(dto.lastName) ?? '',
    headshotUrl: assetUrl(storageBase, headshotPath),
    headshotPath,
    jobTitle: asString(dto.jobTitle),
    company: asString(dto.company),
    bio: asString(dto.bio),
    socialLinks: mapSocialLinks(dto.socialLinks),
    sessionIds: asStringArray(dto.sessionIds),
    archived: asBoolean(dto.archived, false),
  };
}
